module.exports = __webpack_public_path__ + "percent-coin.06e0a191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/percent-coin.png
// module id = 900
// module chunks = 0